export default "__VITE_ASSET__CeE1FcNK__"